import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    popupContext: {
      isNewToShow: false,
      type: null,
      data: null,
    },
    isCaptchaVerified: false,
  },
  getters: {
    popupContext: (state) => {
      return state.popupContext;
    },
    isCaptchaVerified: (state) => {
      return state.isCaptchaVerified;
    },
  },
  mutations: {
    sendNewPopup(state, newPopupContext) {
      state.popupContext.isNewToShow = true;
      state.popupContext.type = newPopupContext.type;
      state.popupContext.data = newPopupContext.data;
    },
    deletePopup(state) {
      state.popupContext.isNewToShow = false;
      state.popupContext.type = null;
      state.popupContext.data = null;
    },
    verifyCaptcha(state) {
      state.isCaptchaVerified = true;
    },
    resetCaptcha(state) {
      state.isCaptchaVerified = false;
    },
  },
  actions: {
    sendNewPopupMessage(context, newPopupContext) {
      context.commit("sendNewPopup", newPopupContext);
    },
    deletePopupMessage(context) {
      context.commit("deletePopup");
    },
    verifyCaptcha(context) {
      context.commit("verifyCaptcha");
    },
    resetCaptcha(context) {
      context.commit("resetCaptcha");
    },
  },
  modules: {},
});
